module.exports = __webpack_public_path__ + "img/CanPay-Logo.b9e47ceb.png";